import {
  configureStore,
  type ConfigureStoreOptions,
  type ThunkDispatch,
} from "@reduxjs/toolkit";

import rootReducer from "@/redux/rootReducer";

// Used to initialize the store for Pages Router
// on the server in createGetServerSideProps
// we should be good to remove after App Router migration
export const makeStore = () =>
  configureStore({
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    reducer: rootReducer,
  });

export const makeStoreWithOverrides = (
  overrideOptions?: Partial<ConfigureStoreOptions>,
) => {
  return configureStore({
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    reducer: rootReducer,
    ...overrideOptions,
  });
};

export type AppStore = ReturnType<typeof makeStore> & {
  dispatch: AppDispatch;
};
export type AppState = ReturnType<AppStore["getState"]>;
export type AppDispatch = ThunkDispatch<
  AppState,
  string,
  Parameters<typeof rootReducer>[1]
>;
